import NoteBox from '@repo/ui/note-box'

import { OptionInput } from '../../../../../lib/types/models/options/option-input'
import { modalButtonConfig } from '../../../../../lib/utils/buttons-config/validation-buttons-config'
import JourneyPlaceDuplicateOptionForm from './journey-place-duplicate-option-form'

type Props = {
  className?: string
  onCancel: () => void
  handleSubmit: (value: OptionInput) => Promise<void>
}

const JourneyPlaceDuplicateOption = ({ className, onCancel, handleSubmit }: Props) => {
  return (
    <div className="flex gap-3 flex-col ">
      <div className={className}>
        <NoteBox
          note="Vous êtes sur le point de dupliquer l'option. Merci de renseigner le nouveau NOM de cette
          option."
        />
      </div>
      <JourneyPlaceDuplicateOptionForm
        className={className}
        buttonsConfig={modalButtonConfig({
          confirmText: 'Dupliquer',
          onCancel,
          onConfirm: handleSubmit
        })}
      />
    </div>
  )
}

export default JourneyPlaceDuplicateOption
